import CareplanTable from './CareplanTable/CareplanTable';
import RODailyAppointment from './DailyAppointments/RODailyAppointment';
import { ROClinicListApollo } from 'op-pages/index';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DashboardLHSPane from './DashboardLHSPane';
import { Stack, Card } from '@mui/material';
import { useState, useContext } from 'react';
import { Region } from 'shared-components/enums';
import { styled } from '@mui/system';
import { UserContext } from 'op-contexts';
import { PermissionType } from 'op-enums';
import { Redirect } from 'react-router-dom';
import './Dashboard.scss';
const REACT_APP_REGION = import.meta.env.REACT_APP_REGION;

// Some legacy jank to remove later
export const StyledTile = styled(Card)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: auto;
  margin: 16px;
  padding: 16px;
`;

const Dashboard = (): JSX.Element => {
  const { path } = useRouteMatch();
  const { hasPermission } = useContext(UserContext);
  const canViewCareplanDashboard = hasPermission(PermissionType.CAREPLAN_DASHBOARD_VIEW);

  const [careplanFilter, setCareplanFilter] = useState<string[]>([]);
  const [statusFilter, setStatusFilter] = useState<string[]>([]);
  const isInUK = REACT_APP_REGION === Region.UK;

  return (
    <Stack direction="row" sx={{ flex: 1, minHeight: 0 }} width={1}>
      <DashboardLHSPane setCareplanFilter={setCareplanFilter} setStatusFilter={setStatusFilter} />
      <Switch>
        <Route path={`${path}/careplans`}>
          {canViewCareplanDashboard ? (
            <CareplanTable
              careplanFilter={careplanFilter}
              statusFilter={statusFilter}
              setCareplanFilter={setCareplanFilter}
              setStatusFilter={setStatusFilter}
            />
          ) : (
            <Redirect to={path} />
          )}
        </Route>
        <Route path={path} component={isInUK ? ROClinicListApollo : RODailyAppointment} />
      </Switch>
    </Stack>
  );
};

export default Dashboard;
